/* eslint-disable @atlaskit/editor/no-re-export */

export { referentialityPlugin, createReferentiality } from '../plugins/referentiality-plugin';
